import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface ParamLibre {
  id?: number;
  nature?: string;
  obligatoire?: boolean;
  titre?: string;
  enabled?: boolean;
  ordre?: number;
  label?: string;
  options?: paramLibreOption[];
  value?: any;
}

export interface paramLibreOption {
  designation: string;
  idParamLibreValeur: number;
}

@Component({
    selector: 'app-params-libre',
    templateUrl: './params-libre.component.html',
    styleUrls: ['./params-libre.component.scss'],
    standalone: false
})
export class ParamsLibreComponent implements OnInit {

  @Input() paramLibre: ParamLibre;
  // @Output() valueEmitter = new EventEmitter();
  label: string;
  valueNull = null;

  constructor() { }

  ngOnInit(): void {
    this.label = this.paramLibre.label ? this.paramLibre.label : this.paramLibre.titre;

    if (this.paramLibre?.options) {
      this.paramLibre.options.sort((a, b) => {
        return a.designation.localeCompare(b.designation, undefined, { sensitivity: 'base' });
      });
    }
  }

  // onChangeModel(value) {
  //   this.valueEmitter.emit(this.paramLibre);
  // }


}
